import React, { useEffect, useState } from "react";
import "./EMSBootEquipments.scss";
import { getEquipments } from "../../api";
import LineItems from "../modals/add-new-application-modal/v2/LineItems";
import { EquipmentContext } from "../modals/add-new-application-modal/useContext/context";

function EmsBootEquipments({ boot_equipments, equipment_json }) {
    const [equipment_json_state, set_equipment_json] = useState({});
    const [allEquipments, setAllEquipments] = useState({});
    const [isDeviceExpanded, setIsDeviceExpanded] = useState(false);
    const [errors, setErrors] = useState({});
    const [categories_selected, setCategoriesSelected] = useState([]);

    useEffect(() => {
        getEquipments()
            .then((res) => {
                const result = res.data.equipments.reduce((acc, current) => {
                    acc[current.id] = current.equipment_name;
                    return acc;
                }, {});
                setAllEquipments(result);
            })
            .catch((err) => {
                console.log(err);
            });
        if (equipment_json) {
            set_equipment_json(JSON.parse(equipment_json));
        }
    }, []);

    return (
        <>
            <EquipmentContext.Provider
                value={{
                    allEquipments,
                    isDeviceExpanded,
                    setIsDeviceExpanded,
                    setErrors,
                    categories_selected,
                    setCategoriesSelected,
                }}
            >
                {Object.entries(equipment_json_state).length > 0 && (
                    <LineItems
                        equipments_data={equipment_json_state}
                        addQuantity={() => {}}
                        removeQuantity={() => {}}
                        updateEquipment={() => {}}
                        removeEquipment={() => {}}
                        allEquipments={allEquipments}
                        action={false}
                    />
                )}
            </EquipmentContext.Provider>
        </>
    );
}

export default EmsBootEquipments;
